import { IS_APP_PRODUCTION } from './app.config';

// Use Vite environment variables for API URLs
const PROD_URL = import.meta.env?.VITE_API_URL_PROD || '';
const DEV_URL = import.meta.env?.VITE_API_URL_DEV || '';

export const API_URL = IS_APP_PRODUCTION ? PROD_URL : DEV_URL;
